import ServiceInstructionModel from "@/models/lab/ServiceInstructionModel";
import LabServiceCollection from "@/collections/LabServiceCollection";

/**
 * ServiceInstruction collection
 */
export default class ServiceInstructionCollection extends LabServiceCollection {

  // Model that is contained in this collection.
  model() {
    return ServiceInstructionModel;
  }

}
